<template>
  <div>
    <e-dialog
      dialog-title="添加商品"
      :center-dialog-visible="addProductVisible"
      popup-width="900px"
      @resetPopupData="handleClose"
      @submitPopupData="submitPopupData"
    >
      <e-search
        :count="count"
        :data="filterInfo.data"
        :field-list="filterInfo.fieldList"
        class="margin-b20"
        @handleFilter="handleFilter"
        @handleReset="handleReset"
        @handleFocus="focusClassify"
      ></e-search>
      <tableList
        ref="multipleTable"
        row-key="skuId"
        :loading="false"
        :table-data="tableData"
        :table-label="tableLabel"
        :selection-show="selectionShow"
        :handle-is-selection="handleIsSelection"
        max-height="220"
        @handleSelectionChange="handleSelectionChange"
      >
        <template #agreementPrice="slot">
          <el-input
            v-model="slot.scope.row.agreementPrice"
            placeholder="请输入"
          ></el-input>
        </template>
      </tableList>
      <div class="pagination flex-right">
        <!--                <div><el-checkbox v-model="selectAllData" :disabled="tableData.length === 0">选择全部商品</el-checkbox></div>-->
        <el-pagination
          background
          :page-sizes="[10, 20, 50, 100, 200]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="queryData.pageNum"
          :page-size="queryData.pageSize"
          :total="queryData.pageTotal"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </e-dialog>
    <e-dialog
      dialog-title="提示"
      :center-dialog-visible="tipVisible"
      :show-btn="showBtn"
      button-tip="继续添加"
      popup-width="700px"
      @resetPopupData="tipVisible = false"
      @submitPopupData="handleAddPopupData"
    >
      <div>
        <!-- <div class="title">以下商品已存在框架协议内，请先删除再向集采协议里添加，如下:</div>
                <ul class="sku-box">
                    <li v-for="(item,index) in tipData" :key="index" class="item-box">
                        商品编号： {{item.skuCode}} , 协议编号： {{item.agreementCode}}
                    </li>
                </ul> -->
        <div class="title">
          以下商品已存在框架协议内，继续添加将在原协议内删除，是否继续添加？
        </div>
        <ul class="sku-box">
          <li v-for="(item, index) in tipData" :key="index" class="item-box">
            商品编号： {{ item.skuCode }} , 协议编号： {{ item.agreementCode }}
          </li>
        </ul>
      </div>
    </e-dialog>

    <!-- 所属分类 -->
    <classifyTree
      :classify-visible="classifyVisible"
      :category-tree-data="categoryTreeData"
      :default-checked-keys="defaultCheckedKeys"
      @submitPopupData="classifySubmitPopupData"
      @resetPopupData="classifyResetPopupData"
    ></classifyTree>
  </div>
</template>

<script>
import eDialog from '@/modules/projectA/components/common/e-dialog.vue';
import tableList from '@/modules/projectA/components/common/e-table-list';
import eSearch from '@/modules/projectA/components/common/e-search';
import api from '../../../../../api/product';
import classifyTree from './classifyTree';

export default {
  name: 'AddProductDialog',
  components: {
    eDialog,
    tableList,
    eSearch,
    classifyTree,
  },
  props: {
    addProductVisible: Boolean,
  },
  data() {
    return {
      tipVisible: false,
      tipData: [],
      tip: '',
      selectAllData: false,
      classifyVisible: false,
      count: 10,
      selectedData: [],
      selectionShow: true,
      filterInfo: {
        data: {
          skuCode: null,
          skuName: null,
          brandName: null,
          categoryName: null,
        },
        fieldList: [
          { label: '商品编号', type: 'input', value: 'skuCode' },
          { label: '商品名称', type: 'input', value: 'skuName' },
          {
            label: '类目名称',
            value: 'categoryName',
            type: 'dialog',
            placeholder: '支持多选',
          },
          { label: '品牌名称', type: 'input', value: 'brandName' },
        ],
      },
      tableData: [],
      tableLabel: [
        { label: '单品编号', param: 'skuCode', align: 'center' },
        { label: '商品名称', param: 'skuName', align: 'center' },
        { label: '类目名称', param: 'categoryName', align: 'center' },
        { label: '计量单位', param: 'unitValue', align: 'center' },
        { label: '品牌', param: 'brandName', align: 'center' },
        { label: '市场价(元)', param: 'price', align: 'center' },
        { label: '惠享价(元)', param: 'sharePrice', align: 'center' },
        {
          label: '集采价(元)',
          param: 'agreementPrice',
          align: 'center',
          slot: 'agreementPrice',
        },
      ],
      queryData: {
        skuCode: null,
        skuName: null,
        brandName: null,
        categoryIdList: null,
        agreementId: '',
        pageNum: 1,
        pageSize: 10,
        pageTotal: 0,
      },
      categoryTreeData: [],
      defaultCheckedKeys: [],
      showCloseBtn: true,
      showBtn: true,
    };
  },
  mounted() {
    this.queryData.agreementId = this.$route.query.agreementId;
    this.queryCentralizedSharePage();
  },
  methods: {
    // 可以勾选的
    handleIsSelection() {
      if (this.selectAllData) {
        return false;
      }
      return true;
    },
    // 搜索得分类弹框
    async queryCentralizedCategoryTreeByAgreementId() {
      const res = await api.queryCentralizedCategoryTreeByAgreementId({
        agreementId: this.queryData.agreementId,
      });
      if (res.success) {
        this.categoryTreeData = res.data.children;
      }
    },
    // 选择所属分类
    focusClassify() {
      this.queryCentralizedCategoryTreeByAgreementId();
      if (this.queryData.categoryIdList?.length) {
        this.defaultCheckedKeys = this.queryData.categoryIdList;
      }
      this.classifyVisible = true;
    },
    // 所属分类确定
    classifySubmitPopupData(val) {
      const filterNode = [];
      val.map((item) => {
        if (item.leafFlag) {
          filterNode.push(item);
        }
      });
      this.queryData.categoryIdList = filterNode.map((item) => item.categoryId);
      const arr = val.map((item) => item.categoryName);
      this.filterInfo.data.categoryName = arr.join('、');
      this.classifyVisible = false;
    },
    // 关闭所属分类弹框
    classifyResetPopupData() {
      this.classifyVisible = false;
    },
    handleSelectionChange(val) {
      this.selectedData = val;
    },
    handleCurrentChange(val) {
      this.queryData.pageNum = val;
      this.queryCentralizedSharePage();
    },
    handleSizeChange(val) {
      this.queryData.pageNum = 1;
      this.queryData.pageSize = val;
      this.queryCentralizedSharePage();
    },
    handleFilter(val) {
      this.queryData.skuCode = val.skuCode;
      this.queryData.skuName = val.skuName;
      this.queryData.brandName = val.brandName;
      this.queryData.pageNum = 1;
      this.queryCentralizedSharePage();
    },
    handleReset() {
      this.queryData = {
        skuCode: null,
        skuName: null,
        brandName: null,
        categoryIdList: null,
        agreementId: this.$route.query.agreementId,
        pageNum: 1,
        pageSize: 10,
        pageTotal: 0,
      };
      (this.filterInfo.data.categoryName = null),
        this.queryCentralizedSharePage();
    },
    handleClose() {
      this.$emit('handleClose', 'addProductVisible');
    },
    testPrice() {
      let testPriceFlag = false;
      for (let i = 0; i < this.selectedData.length; i++) {
        if (
          Number(this.selectedData[i].agreementPrice) >
          Number(this.selectedData[i].sharePrice)
        ) {
          testPriceFlag = true;
          this.tip = '集采价不能高于惠享价。';
          break;
        }
        if (Number(this.selectedData[i].agreementPrice) === 0) {
          testPriceFlag = true;
          this.tip = '集采价不能为0。';
          break;
        }
      }
      return testPriceFlag;
    },
    async submitPopupData() {
      if (this.selectedData.length === 0 && !this.selectAllData) {
        this.$message.warning('请选择要添加的商品。');
        return false;
      }

      // 校验集采价不能高于惠享价
      if (!this.selectAllData && this.testPrice()) {
        this.$message.warning(this.tip);
        return false;
      }

      if (this.selectAllData) {
        this.addByCondition(); // 勾选全部商品添加接口
      } else {
        this.centralizedBatchAdd();
      }
    },
    // 勾选全部添加
    async addByCondition() {
      const res = await api.addByCondition(this.queryData);
      if (res.success) {
        this.$message.success('添加成功！');
        this.handleClose();
      }
    },
    // 单独勾选添加
    async centralizedBatchAdd() {
      const agreementPriceEditList = this.selectedData.map(
        ({ skuId, agreementPrice, supplierCompanyId }) => ({
          skuId,
          agreementPrice,
          supplierCompanyId,
        })
      );

      const params = {
        agreementId: this.queryData.agreementId,
        agreementPriceEditList,
      };
      // let res = await api.centralizedBatchAdd(params);
      const res = await api.checkSkuExist(params);
      if (res.code === '200') {
        if (res.data.agreementPriceEditList.length > 0) {
          // 有已经存在的商品
          this.tipData = res.data.agreementPriceEditList;
          this.tipVisible = true;
        } else {
          const res = await api.centralizedBatchAdd(params);
          if (res.code === '200') {
            this.$message.success('添加成功！');
            this.handleClose();
          }
        }
      }
    },
    async handleAddPopupData() {
      const agreementPriceEditList = this.selectedData.map(
        ({ skuId, agreementPrice, supplierCompanyId }) => ({
          skuId,
          agreementPrice,
          supplierCompanyId,
        })
      );

      const params = {
        agreementId: this.queryData.agreementId,
        agreementPriceEditList,
      };
      const res = await api.centralizedBatchAdd(params);
      if (res.code === '200') {
        this.tipVisible = false;
        this.$message.success('添加成功！');
        this.handleClose();
      }
    },

    async queryCentralizedSharePage() {
      const res = await api.queryCentralizedSharePage(this.queryData);
      if (res.success) {
        this.tableData = res.data.records || [];
        this.tableData.forEach((item) => {
          if (!item.agreementPrice) {
            this.$set(item, 'agreementPrice', '');
          }
        });
        this.queryData.pageTotal = res.data.total;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.title {
  color: #ef4c56;
  margin-bottom: 10px;
}
.sku-box {
  max-height: 300px;
  overflow-y: auto;
  .item-box {
    padding: 0 10px;
    height: 36px;
    line-height: 36px;
    &:hover {
      background-color: #ededed;
      cursor: pointer;
    }
  }
}
</style>
